<div *ngIf="status | async as s" class="row">
    <div [ngClass]="{'col-md-9': s.result.status === 'review',
                     'col-md-12': s.result.status === 'approved'}" style="padding-top:10px;">
        Status: {{ s.result.status | display:s.meta.fields.status.choices }}
    </div>
    <div class="col-md-3" *ngIf="(s.result.status === 'review') && s.meta.permissions.write">
        <button class="btn btn-primary pull-right" id="reviewed_input"
                (click)="updateStatus(s.result)">
            Approve
        </button>
    </div>
</div>
